import styled from '@emotion/styled';

import { ButtonElementProps } from './types';

export const ButtonElement = styled('button')<ButtonElementProps>`
  font-family: ${({ theme }) => theme.general.font_family};
  font-size: ${({ theme }) => theme.general.font_size};
  gap: ${({ theme }) => theme.general.gap};
  height: ${({ height }) => height};
  border-radius: ${({ theme }) => theme.general.border_radius};
  background: ${({ theme }) => theme.background.normal};
  border: ${({ theme }) => theme.border.normal};
  color: ${({ theme }) => theme.color.normal};
  padding: ${({ theme }) => theme.general.padding};

  &:hover {
    background: ${({ theme }) => theme.background.hover};
    border: ${({ theme }) => theme.border.hover};
    color: ${({ theme }) => theme.color.normal};
  }

  &:active {
    background: ${({ theme }) => theme.background.active};
    border: ${({ theme }) => theme.border.active};
    color: ${({ theme }) => theme.color.normal};
  }

  &[data-disabled='true'] {
    background: ${({ theme }) => theme.background.disabled};
    border: ${({ theme }) => theme.border.disabled};
    color: ${({ theme }) => theme.color.disabled};
    pointer-events: none;
    opacity: 0.8;
  }
`;
